import { render, staticRenderFns } from "./WriteNewsPost.vue?vue&type=template&id=4c76c250&"
import script from "./WriteNewsPost.vue?vue&type=script&lang=js&"
export * from "./WriteNewsPost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports